import { RoleStrip } from "./kit";
import { chipsPressed } from "../lib/groundsView";

/**
 * #1411 (D367.19) — the Played / Near me / All chips under the Grounds search field (the round-12 board draws a
 * source Select there and no chip row, so they sit under the field, D259). Three chips, 44px tap boxes (G4, D354).
 * `Near me` asks for the device position exactly as "Use my location" does, on the tap and never before.
 */
export default function GroundsViewChips({ view, positionKnown, locating, audience, onPlayed, onNear, onAll }) {
  const options = [
    { value: "played", label: audience === "coach" ? "Added" : "Played", "data-testid": "grounds-view-played" },
    { value: "near", label: locating ? "Finding you…" : "Near me", "data-testid": "grounds-view-near" },
    { value: "all", label: "All", "data-testid": "grounds-view-all" },
  ];
  const handlers = { played: onPlayed, near: onNear, all: onAll };
  return (
    <RoleStrip
      data-testid="grounds-view-chips"
      aria-label="Which grounds the map shows"
      options={options}
      value={chipsPressed(view, positionKnown)}
      onChange={(v) => handlers[v]?.()}
      gap={6}
      tapBox
    />
  );
}
